export default __webpack_public_path__ + "static/student-enrollment-lms-integration-aa868dde669d5f2efbd18e721c5437c7.jpg";